module.exports = __webpack_public_path__ + "static/002-fe265e012c8903af9100472bae2f28e1.jpg";